import Header from "./components/portfolia/Header/header.js";
import Home from "./components/portfolia/Home/Home.js";
import About from "./components/portfolia/About/about.js";
import Service from "./components/portfolia/MyServices/services.js";
import Projects from "./components/portfolia/MyWork/myWork.js";
import Contact from "./components/portfolia/contact/contact.js";
import Footer from "./components/portfolia/Footer/footer.js";

function App() {
  return (
    <div>
      <Header/>
      <Home/>
      <About/>
      <Service/>
      <Projects/>
      <Contact/>
      <Footer/>
    </div>
  );
   
}

export default App;
